import { navTypes } from '../Types/Nav.types';

export const slideMenu = () => ({
  type: navTypes.MENU_SLIDE,
});
